import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { unwrapOr } from "../../utilities/general";

const responseSchema = yup
  .array()
  .of(
    yup.object({
      id: yup.number().required(),
      name: yup.string().required(),
    }),
  )
  .required();

const composeResponse = (res) => {
  const data = unwrapOr(() => res.data.data, {});
  return Object.values(data).map((d) => ({
    id: d.id,
    name: d.tier_name,
  }));
};

export function useMembershipsObOrderQuery({ options = {} }) {
  return useQuery(
    [QUERY_KEYS.membershipsObOrder],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getMembershipsObOrder());
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
}
